/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and international
 * treaties. Unauthorized use, reproduction, distribution, or modification of any content
 * from Knowledge for Decisions (K4D) is strictly prohibited. For inquiries regarding
 * the use or licensing of K4D's copyrighted materials, please contact us at
 * contact@k4d.com.br."Knowledge for Decisions (K4D)" and the slogan"Using data to make
 * precise decisions" are registered trademarks of Knowledge for Decisions (K4D).
 */

import { cn } from"@/shared/ui/utils/tailwind";

export type DividerProps = {
  orientation?:"horizontal" |"vertical";
  /** Legacy flex-style alias:"col"/"column" maps to vertical,"row" to horizontal. */
  direction?:"row" |"col" |"column";
  className?: string;
};

/**
 * Divider component with Tailwind styling
 * Replaces Mantine Divider
 */
export const Divider: React.FC<DividerProps> = ({
  orientation,
  direction,
  className,
}) => {
  const resolvedOrientation =
    orientation ?? (direction ==="col" || direction ==="column" ?"vertical" :"horizontal");
  if (resolvedOrientation ==="vertical") {
    return (
      <div
        className={cn(
          "w-px h-full bg-[var(--border-medium)]",
          "",
          className
        )}
        role="separator"
        aria-orientation="vertical"
      />
    );
  }

  return (
    <hr
      className={cn(
        "border-0 border-t border-[var(--border-medium)]",
        "",
        "my-4",
        className
      )}
      role="separator"
      aria-orientation="horizontal"
    />
  );
};

export default Divider;
